export const typeOfSuggestModal = 'typeOfSuggestModal';
export const suggestModalReducerKey = 'suggestModalReducerKey';

export const suggestModalSetIsLoadingReducerType = 'suggestModalSetIsLoadingReducerType';
export const suggestModalSetIsNextPageLoadingReducerType = 'suggestModalSetIsNextPageLoadingReducerType';
export const suggestModalSetCurrentDBReducerType = 'suggestModalSetCurrentDBReducerType';
export const suggestModalSetNoDataReducerType = 'suggestModalSetNoDataReducerType';
export const suggestModalSetOpModelReducerType = 'suggestModalSetOpModelReducerType';
export const suggestModalSetHighlightedItemReducerType = 'suggestModalSetHighlightedItemReducerType';
export const suggestModalSetCurrentPageReducerType = 'suggestModalSetCurrentPageReducerType';
export const suggestModalSetExpandedValueReducerType = 'suggestModalSetExpandedValueReducerType';
export const suggestModalSetSuggestConfigReducerType = 'suggestModalSetSuggestConfigReducerType';
export const suggestModalSetFullUpdateReducerType = 'suggestModalSetFullUpdateReducerType';

export const ITEMS_PER_PAGE = 15;
export const BUFFER_SIZE = 30;
